export default __webpack_public_path__ + "static/media/icon-em-open-rate.80650c85.svg";